import React from "react"

import AccountInfo from "./views/AccountInfo";
import EditUser from "./views/EditUser";
import Payments from "./views/Payments";
import PlanSuscription from "./views/PlanSuscription";
import ModulesUpgrades from "./views/ModulesUpgrades";

class Layout extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            show_edited_notification : false,
            show_pasword_changed_notification : false
        }

        this.setEditedNotification = this.setEditedNotification.bind(this);
        this.setPasswordNotification = this.setPasswordNotification.bind(this);
    }

    setEditedNotification(state){
        let self = this;
        self.setState({
            show_edited_notification : state
        });
    }
    setPasswordNotification(state){
        let self = this;
        self.setState({
            show_pasword_changed_notification : state
        });
    }
    render() {
        return (
            <div className="layout">
            {(this.props.app.state.section_active === "account-data") && 
                <div className={"account-data section-show"}>
                    <AccountInfo
                        app={this.props.app}
                        handleNotification = {this.props.handleNotification}
                        item_active={this.props.item_active}
                        activeSection={this.props.activeSection}
                        getHotels = {this.props.getHotels}
                        users = {this.props.users}
                        roles={this.props.roles}
                        business_id={this.props.business_id}
                        getUsers = {this.props.getUsers}
                        setEditingUser = {this.props.setEditingUser}
                        editing_user = {this.props.editing_user}
                        loading_users = {this.props.loading_users}
                        user_id = {this.props.user_id}
                        show_pasword_changed_notification = {this.state.show_pasword_changed_notification}
                        show_edited_notification = {this.state.show_edited_notification}
                        setEditedNotification = {this.setEditedNotification}
                        setPasswordNotification = {this.setPasswordNotification}
                    />
                </div>
            }
            {(this.props.app.state.section_active === "edit") && 
                <div className={"adduser section-show"}>
                    <EditUser
                        app={this.props.app}
                        handleNotification = {this.props.handleNotification}
                        item_active={this.props.item_active}
                        activeSection={this.props.activeSection}
                        getHotels = {this.props.getHotels}
                        users = {this.props.users}
                        roles={this.props.roles}
                        business_id={this.props.business_id}
                        getUsers = {this.props.getUsers}
                        setEditingUser = {this.props.setEditingUser}
                        editing_user = {this.props.editing_user}
                        loading_users = {this.props.loading_users}
                        user_id = {this.props.user_id}
                        setEditedNotification = {this.setEditedNotification}
                        setPasswordNotification = {this.setPasswordNotification}
                    />
                </div>
            }
            {(this.props.app.state.section_active === "plan-suscription") && 
                <div className={"plan-suscription section-show"}>
                    <PlanSuscription
                    />
                </div>
            }
            {(this.props.app.state.section_active === "modules-upgrades") && 
                <div className={"modules-upgrades section-show"}>
                    <ModulesUpgrades
                    />
                </div>
            }
            {(this.props.app.state.section_active === "payments") && 
                <div className={"payments "}>
                    <Payments
                    />
                </div>
            }   
                
            </div>
        )
    }

}

export default Layout


// WEBPACK FOOTER //
// ./src/Setup/modules/account/Layout.js